import { render } from "./BudgetCalculator.vue?vue&type=template&id=893d7af0"
import script from "./BudgetCalculator.vue?vue&type=script&lang=js"
export * from "./BudgetCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__